import { Locale } from "../types";
import { Product, ProductsById, Variation } from "../types/product";
import spicyImage from "@/assets/spicy.png";

const getProductVariations = (
  item: Product,
  allProducts: ProductsById,
  variations: Variation[],
): Variation[] => {
  const itemVariations = item?.variations;

  return itemVariations && itemVariations.length > 0
    ? itemVariations.map((variation) => {
        const variationItem = allProducts[`${variation.productId}`];
        const cost = variationItem ? variationItem.price - item.price : 0;
        const inStock =
          variationItem && variationItem.inStock !== undefined
            ? variationItem.inStock
            : true;
        const variationConfigData = variations.find(
          (localVariation) => localVariation.name === variation.name,
        ) || { id: 0, iconImage: "", isSelected: false };

        return {
          ...variationConfigData,
          ...variation,
          cost,
          inStock,
        };
      })
    : [];
};

const getSelectedVariation = (
  itemVariations: Variation[],
  item: Product,
  productsById: ProductsById,
) => {
  const selectedVariation = itemVariations.find(
    (variation) => variation.isSelected,
  );
  if (selectedVariation && selectedVariation.productId !== undefined) {
    return {
      selectedVariation,
      variationItem: productsById[`${selectedVariation.productId}`],
    };
  }
  return {
    selectedVariation,
    variationItem: item,
  };
};

export const variations = (locale: Locale): Variation[] => [
  {
    id: 1,
    name: "Spicy",
    cost: 0,
    iconImage: spicyImage,
    isSelected: false,
    inStock: false,
  },
];

export { getProductVariations, getSelectedVariation };
